import { AutogenModelMiscBill, AutogenRowMiscBill } from "./autogen/AutogenModelMiscBill";

export class ModelMiscBill extends AutogenModelMiscBill<RowMiscBill> {
	constructor() {
		super(RowMiscBill);
	}
}

export class RowMiscBill extends AutogenRowMiscBill {
}